<template>
    <div class="login-code-row">
        <template v-for="i in code.length">
            <div :key="i" class="login-code-col">
                <input
                    v-model="code[i - 1]"
                    :ref="`code_${i - 1}`"
                    @keyup="goToNextInput($event, i - 1)"
                    @keydown="onKeyDown($event, i - 1)"
                    @click="$event.target.select()"
                    type="text"
                    maxLength="1"
                    size="1"
                    min="0"
                    max="9"
                    :disabled="disabled"
                    pattern="[0-9]{1}"
                    class="registration-form__text-field"
                    :title="`QR code ${i}`"/>
            </div>
            <div v-if="i === 3" class="login-code-col">一</div>
        </template>
    </div>
</template>

<script>
const KEY_CODE_BACKSPACE = 8
const KEY_CODE_TAB = 9
const KEY_CODE_DELETE = 46

export default {
    name: 'TwoFactorCode',
    props: {
        disabled: {
            default: false
        }
    },
    data() {
        return {
            code: ['', '', '', '', '', '']
        }
    },
    methods: {
        handleCodeInput() {
            this.$emit('input', this.code.join(''))
        },

        onKeyDown(event, i) {
            const key = event.which
            if (key === KEY_CODE_TAB || isFinite(event.key)) {
                return true
            }
            if (key === KEY_CODE_BACKSPACE) {
                const idx = i === 0 ? 0 : i - 1
                const el = this.$refs['code_' + idx][0]
                this.code.splice(this.code[i] ? i : idx, 1, '')
                el.select()
                el.focus()
                return true
            }
            if (key === KEY_CODE_DELETE) {
                this.code[i - 1] = ''
                return true
            }
            event.preventDefault()
            return false
        },

        goToNextInput(event, i) {
            const idx = i === 5 ? 0 : i + 1
            const key = event.which
            if (key !== KEY_CODE_TAB && !isFinite(event.key)) {
                event.preventDefault()
                return
            }
            if (key === KEY_CODE_TAB) {
                return
            }
            const el = this.$refs['code_' + idx][0]
            if (el) {
                el.select()
                el.focus()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs['code_0'][0].focus()
        })
        this.$bus.$on('CLEAR_2FA_CODE', () => {
            this.code = ['', '', '', '', '', '']
        })
    },
    watch: {
        code: 'handleCodeInput'
    }
}
</script>

<style scoped lang="scss">
    .login-code-row {
        margin: 0 -5px 10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .login-code-row .registration-form__text-field {
        margin: 0;
        text-align: center;
        padding: 4px;
    }

    .login-code-col {
        padding: 0 5px;
        flex: 1 0 0;
        text-align: center;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
        /* Firefox */
    }

    .registration-form__text-field {
        display: block;
        width: 100%;
        height: 42px;
        border: 1px solid #d8d8d8;
        border-radius: 5px !important;
        background: none;
        box-shadow: 0 0 10px rgba(208, 208, 208, 0.07) inset;
        padding: 4px 14px;
        margin: 0 0 20px;
        line-height: 22px;
        transition: all 0.4s;
        font-size: 14px;
    }

    .registration-form__text-field:focus {
        border: 1px solid #999;
    }

    .registration-form__text-field + .registration__error-message {
        margin: -17px 0 20px;
    }
</style>
